import { render, staticRenderFns } from "./AppealView.vue?vue&type=template&id=24fc7998&scoped=true"
import script from "./AppealView.vue?vue&type=script&lang=js"
export * from "./AppealView.vue?vue&type=script&lang=js"
import style0 from "./AppealView.vue?vue&type=style&index=0&id=24fc7998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc7998",
  null
  
)

export default component.exports